<template>
 <page>

    <head-nav :title="album.title">
        <icon-button-back slot="left"></icon-button-back>
        <icon-button-home slot="right"></icon-button-home>
      </head-nav>
      <scroll-page>
   <caroussel :medias="album.items"/>
   
   <page-padding>
         <text-block v-html="album.description"></text-block>
      </page-padding>
  </scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import PagePadding from '../components/PagePadding.vue';

import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import Caroussel from '../components/caroussel/Caroussel.vue';
import ScrollPage from '../components/ScrollPage.vue';
import TextBlock from '../components/TextBlock.vue';

export default {
  name: 'view-photoalbum-page',
  data:function(){
    return{
      item_id:this.$route.params.id,
      item:{},
    }
  },
  computed:{
     ...mapState([
       'album'
       ]),
       computeMedias:function(){
         return this.album ? this.album.items : [];
       },
  },
  components: {
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    Page,
    Caroussel,
    ScrollPage,
    TextBlock,
  },
  methods:{
    loadAlbum(){
      var payload={id:this.item_id}
      this.$store.dispatch('get_album',payload)
    }
  },
  created(){
    this.loadAlbum();
  },
  mounted(){
   
    
    
  }
}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.start_time{
  margin-bottom:10px;
  
  
}
.end_time{
  margin-bottom:10px;
  
 
}
.title{
  margin-bottom:10px;
   color:#707070;
}
.description{
  margin-bottom:10px;
   color:#707070;
}
</style>
